import * as Sentry from '@sentry/react';
import { FeatureErrorFallback } from '../Abstracts/ErrorFallback/FeatureErrorFallback/FeatureErrorFallback';

export function FeatureErrorBoundary({
  children,
  featureName,
}: {
  children: React.ReactNode;
  featureName: string;
}) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <FeatureErrorFallback featureName={featureName} onReset={resetError} />
      )}
      beforeCapture={(scope, error) => {
        scope.setTag('boundary', 'feature');
        scope.setTag('feature_name', featureName);
        scope.setTag(
          'sentry_error_name',
          error instanceof Error ? error.name : 'Unknown'
        );
        scope.setTag('environment', process.env.NODE_ENV);

        scope.setLevel('error');
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
